import { render } from "./ProvidedFeedback.vue?vue&type=template&id=08fd3be4&scoped=true"
const script = {}

import "./ProvidedFeedback.vue?vue&type=style&index=0&id=08fd3be4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fd3be4"]])

export default __exports__